import axios, { Method, AxiosPromise } from 'axios';
import { config } from '../config';

function createAxiosInstance() {
  const axiosInstance = axios.create({
    baseURL: config.apiBaseUrl,
    responseType: 'json',
    withCredentials: true,
  });

  if (config.apiManagementKey) {
    axiosInstance.defaults.headers = {
      // Authorization: 'Bearer ' + token || '',
      'Ocp-Apim-Subscription-Key': config.apiManagementKey,
    };
  }

  return axiosInstance;
}

const axiosInstance = createAxiosInstance();

export function sendRequest(
  method: Method = 'get',
  url: string,
  data?: any
): AxiosPromise<any> {
  return axiosInstance({
    method: method,
    url: url,
    data: data,
  });
}

export function setToken(token: string) {
  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
}
